import {
    BOOK_WITH_ME_PATH_NAME,
    ORGANIZER_PAGE_KEYWORD,
} from '../store/schema/BookWithMeRouteConstants';

export default function getOrganizerURL(): string {
    // Attaching the URL to the button
    // to add the functionality to use the right click too
    const ORGANIZER_URL =
        'https://' +
        window.location.host +
        '/' +
        BOOK_WITH_ME_PATH_NAME +
        '/' +
        ORGANIZER_PAGE_KEYWORD +
        '?ep=meetingDetails';
    return ORGANIZER_URL;
}
